import {makeLxTranslations} from "@lxo-blocks/react";

const PASSWORD_INPUT_TRANSLATION =  makeLxTranslations({
    namespace: "passwordInputTranslations",
    translations: {
        PASSWORD_HINT_8_CHARS: "8 Zeichen",
        PASSWORD_HINT_UPPER_CASE: "Großbuchstabe",
        PASSWORD_HINT_NUMBER_OR_SPECIAL_CHAR: "Zahl oder Sonderzeichen",
        PASSWORD_HINT_LOWER_CASE: "Kleinbuchstabe",
        ERROR_PASSWORDS_DO_NOT_MATCH: "Die Passworte stimmen nicht überein",
        ERROR_PASSWORD_NOT_VALID: "Bitte geben Sie ein gültiges Passwort ein",
    }
});

export {PASSWORD_INPUT_TRANSLATION};
